<template>
  <div class="h-screen flex overflow-hidden">
    <!-- Top menu -->
    <div class="fixed top-0 right-0 z-50 bg-gray-50 dark:bg-gray-900 w-full h-16">
      <top-menu/>
    </div>

    <!-- Side menu -->
    <div class="fixed top-16 bottom-0 overflow-auto w-64">
      <left-menu/>
    </div>

    <!-- Main content -->
    <div class="dark:bg-gray-900 md:ml-64 mt-16 p-4 bg-gray-50 overflow-auto md:w-full md:w-[calc(100%-16rem)]">
      <div class="p-4 rounded-lg dark:border-gray-700 dark:bg-gray-900">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

import TopMenu from "./components/topMenu.vue";
import LeftMenu from "./components/leftMenu.vue";

export default {
  name: "default",
  components: {LeftMenu, TopMenu},
}
</script>

<style scoped>

</style>